// src/components/LimitPopup.jsx
import React, { useEffect } from "react";

export default function LimitPopup({
  open,
  title,
  message,
  nextAllowedAt,
  onClose,
}) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const formatDate = (v) => {
    if (!v) return "";
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return String(v);
    return d.toLocaleString("he-IL", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const nextText = nextAllowedAt ? formatDate(nextAllowedAt) : "";

  return (
    <div dir="rtl">
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.62)",
          backdropFilter: "blur(4px)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px",
        }}
      >
        {/* Card */}
        <div
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          style={{
            width: "100%",
            maxWidth: "460px",
            background: "#0b1220",
            border: "1px solid rgba(255,255,255,0.10)",
            borderRadius: "18px",
            boxShadow:
              "0 24px 80px rgba(0,0,0,0.55), 0 2px 0 rgba(255,255,255,0.04) inset",
            overflow: "hidden",
            transform: "translateY(0)",
            animation: "limitPopIn .18s ease-out",
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "16px 16px 10px 16px",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: "10px",
            }}
          >
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {/* Icon bubble */}
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "12px",
                  background: "rgba(255, 193, 7, 0.12)",
                  border: "1px solid rgba(255, 193, 7, 0.22)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flex: "0 0 auto",
                }}
                aria-hidden="true"
              >
                <span style={{ fontSize: 18 }}>⚠️</span>
              </div>

              <div style={{ textAlign: "right" }}>
                <div
                  style={{
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: 800,
                    lineHeight: 1.2,
                  }}
                >
                  {title || "הוספת רכב מוגבלת"}
                </div>
                <div
                  style={{
                    color: "rgba(255,255,255,0.65)",
                    fontSize: "12.5px",
                    marginTop: "3px",
                  }}
                >
                  {nextText ? `זמין שוב החל מ־${nextText}` : "אנא בדקי את המכסה שלך"}
                </div>
              </div>
            </div>

            {/* Close */}
            <button
              type="button"
              onClick={onClose}
              aria-label="סגירה"
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "12px",
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.10)",
                color: "rgba(255,255,255,0.85)",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "0 16px 14px 16px" }}>
            <div
              style={{
                textAlign: "right",
                color: "rgba(255,255,255,0.88)",
                fontSize: "14px",
                lineHeight: 1.6,
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "14px",
                padding: "12px 12px",
              }}
            >
              {message || "מוכר פרטי יכול להעלות רכב אחד בלבד בכל 30 ימים."}
            </div>

           
          </div>

          {/* Footer */}
          <div
            style={{
              padding: "12px 16px 16px 16px",
              display: "flex",
              gap: "10px",
              justifyContent: "flex-end",
              borderTop: "1px solid rgba(255,255,255,0.08)",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.00))",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: "10px 14px",
                borderRadius: "12px",
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.12)",
                color: "#fff",
                fontWeight: 700,
                cursor: "pointer",
              }}
            >
              הבנתי
            </button>

            {/* אם תרצי כפתור נוסף בעתיד (ליצירת קשר / שדרוג) אפשר להוסיף כאן */}
          </div>

          {/* Inline keyframes */}
          <style>{`
            @keyframes limitPopIn {
              from { opacity: 0; transform: translateY(8px) scale(0.99); }
              to   { opacity: 1; transform: translateY(0) scale(1); }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
}
